import { defineMessages } from 'react-intl';

export default defineMessages({
  callToActionButton: {
    id: 'portfolio.badge.callToActionButton',
    description: 'Call to action button for company brochure',
    defaultMessage: 'Katso esite',
  },
});
